/*
 *
 * ForgotPassword actions
 *
 */

import { createAction } from '@reduxjs/toolkit';
import { REQUEST_RESET_LINK, RESET_REQUEST_RESET_LINK } from './constants';

export const requestResetAct = createAction(
  REQUEST_RESET_LINK,
  (loadingState, data) => ({
    payload: {
      loadingState,
      data,
    },
  }),
);

export const resetRequestResetAct = createAction(RESET_REQUEST_RESET_LINK);
